export default function(callback, that) {
  let index = -1;
  for (const node of this) {
    if (callback.call(that, node, ++index, this)) {
      return node;
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/hierarchy/find.js
// module id = 540
// module chunks = 0